// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"98c3048a","70":"15d31468","87":"04a9c8b7","95":"baca2502","254":"9b49633e","431":"9aef9572","524":"a1bcf211","569":"5fcc855e","723":"bce1cf73","787":"4d6363c9"}[chunkId] + ".chunk.js";
};